import React from 'react'
import { useHistory } from 'react-router'

import TaskCard from '../TaskCard'

import { Routes } from '../../../../../Routes'
import { useTaskList } from '../../../../../providers/TaskListProvider'
import { useTaskPageState } from '../../../../../providers/TaskPageStateProvider'
import useStyles from './styles'

type TaskCardsProps = {
  tasks: LocalTask[]
  containerID: string
  children: React.ReactNode
}

const TaskCards: React.FC<TaskCardsProps> = ({
  tasks,
  containerID,
  children
}) => {
  const history = useHistory()

  const { setIDs } = useTaskList()
  const { setLastViewedColumn, setLastViewedCard } = useTaskPageState()

  const classes = useStyles()

  const handleClick = React.useCallback(
    (id: string) => {
      setLastViewedColumn(containerID)
      setLastViewedCard(id)

      // Update task arrows
      const ids = tasks.map(task => task.id)
      setIDs(ids, id)

      // Go to task
      history.push(`${Routes.TASKS}/${id}`)
    },
    [
      setLastViewedColumn,
      setLastViewedCard,
      containerID,
      setIDs,
      tasks,
      history
    ]
  )

  return (
    <div className={classes.root}>
      {tasks.map(task => (
        <TaskCard
          key={task.id}
          task={task}
          onClick={() => handleClick(task.id)}
          containerID={containerID}
        />
      ))}

      {children}
    </div>
  )
}

export default TaskCards
